import { graphql } from 'relay-runtime';

export const COMMUNITY_INITIALIZE_MUTATION = graphql`
  mutation CommunityInitializeMutation($aaid: String, $emailId: String) {
    unified {
      community {
        initializeCommunity(aaid: $aaid, emailId: $emailId) {
          errors {
            code
            extensions {
              errorType
              statusCode
            }
            message
          }
          forumsProfile {
            id
          }
          success
          gamificationProfile {
            userId
          }
          unifiedProfile {
            aaid
            accountInternalId
            internalId
            id
          }
        }
      }
    }
  }
`;
